import { filterSupportedQueryFields } from '@/shared/data/queryFilters';
import type { GridFilters } from '@/ui/composites/grid/gridFilters';

const releaseQueryFilterFields = new Set([
  'name',
  'slug',
  'status',
  'featureStatus',
  'testingStatus',
  'tags',
  'plannedFor',
  'releasedAt',
  'createdAt',
  'deliveryDateWindow',
  'id',
  'projectId',
  'projectName',
  'organisationId',
]);

export const filterReleaseQueryFields = (filters: GridFilters): GridFilters =>
  filterSupportedQueryFields(filters, releaseQueryFilterFields);
